import React from "react";

const WorkoutGeneratorHelp = () => (
  <div>
    <h2>Workout Generator Help Guide</h2>
    <p>
      Learn how to use the Workout Generator to create your customized fitness plan. This guide will walk you through the steps and features of the tool.
    </p>

    <h3>Getting Started</h3>
    <ol>
      <li>Enter your fitness level, areas of focus, available equipment, and any injuries you may have into the input form.</li>
      <li>Click "Generate Plan" to create a tailored workout schedule.</li>
      <li>Review the generated plan, including exercises, target areas, and progression guidelines.</li>
    </ol>
    <p>
      <strong>Example:</strong> Select "Intermediate" fitness level, set your area of focus as "Core" and "Upper Body", choose available equipment like "Dumbbells", "Eliptical", and "Kettlebell", then add any current injuries such as "ACL Tear", etc.
    </p>

    <h3>Features</h3>
    <ul>
      <li>Personalized Weekly Schedule</li>
      <li>Exercise Details with Target Areas</li>
      <li>Progression Guidelines</li>
      <li>Rest Day Recommendations</li>
      <li>Printer-Friendly Plan</li>
      <li>Tips for Success</li>
    </ul>

    <h3>Understanding Results</h3>
    <h4>Plan Components</h4>
    <ul>
      <li>
        <strong>Weekly Schedule:</strong> Details workout days, specific focus areas, and exercises.
      </li>
      <li>
        <strong>Exercise Details:</strong> Includes target areas, recommended sets, reps, and durations.
      </li>
      <li>
        <strong>Progression Guidelines:</strong> Provides instructions for advancing and modifying exercises.
      </li>
    </ul>

    <h3>Tips for Success</h3>
    <ul>
      <li>Review the entire workout plan before starting.</li>
      <li>Follow the recommended sets, reps, and rest times.</li>
      <li>Use the "Print View" feature to keep a physical copy of your plan.</li>
      <li>Pay attention to rest days and recovery recommendations.</li>
      <li>Track your progress and adjust the intensity as needed.</li>
    </ul>

    <h3>Printing Results</h3>
    <h4>How to Print</h4>
    <ol>
      <li>Review the complete workout plan.</li>
      <li>Click the "Print View" button at the bottom of the plan.</li>
      <li>Use your browser's print function or system print dialog to print the plan.</li>
    </ol>

    <h3>Important Notes</h3>
    <ul>
      <li>Warm up properly before starting your workout.</li>
      <li>Listen to your body and adjust the intensity as needed.</li>
      <li>Consult a healthcare provider before starting any new exercise program.</li>
      <li>Stay hydrated and maintain proper form during exercises.</li>
    </ul>
  </div>
);

export default WorkoutGeneratorHelp;
